var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    { staticClass: "ma-0 pa-0", attrs: { cols: "12", id: "head_title" } },
    [
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { cols: "12", id: "main_content_maxwidthset" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "ma-0 pa-0",
              attrs: {
                align: "center",
                justify: "space-between",
                id: "header_height",
              },
            },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-0 pa-0",
                      class: { current_btn: _vm.currentRoute == "groupDetail" },
                      attrs: {
                        width: "9rem",
                        height: "50px",
                        id: "header_btn1",
                        elevation: "0",
                      },
                      on: { click: _vm.goGroupDetail },
                    },
                    [_vm._v(" " + _vm._s(_vm.tsg("storeList")) + " ")]
                  ),
                  _vm.authorities.GET_RECORDING_SUB_BRANCH
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          class: {
                            current_btn:
                              _vm.currentRoute == "splitScreenViewSelect" ||
                              _vm.currentRoute == "splitScreenCameraSelect" ||
                              _vm.currentRoute == "splitScreen",
                          },
                          attrs: {
                            width: "9rem",
                            height: "50px",
                            id: "header_btn2",
                            elevation: "0",
                          },
                          on: { click: _vm.goSplitScreen },
                        },
                        [_vm._v(" " + _vm._s(_vm.tsg("splitScreen")) + " ")]
                      )
                    : _vm._e(),
                  _vm.authorities.GET_RECORDING_SUB_BRANCH
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 pa-0",
                          class: {
                            current_btn:
                              _vm.currentRoute == "cctvCameraList" ||
                              _vm.currentRoute == "cctvSearch" ||
                              _vm.currentRoute == "cctvCameraListView",
                          },
                          attrs: {
                            width: "9rem",
                            height: "50px",
                            id: "header_btn3",
                            elevation: "0",
                          },
                          on: { click: _vm.goCCTVCameraList },
                        },
                        [_vm._v(" " + _vm._s(_vm.tsg("cameraList")) + " ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.authorities.ADD_STORE_GROUP
                ? _c(
                    "v-row",
                    {
                      staticClass: "ma-0 pa-0",
                      attrs: { align: "center", justify: "end" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "back_clean_btn ma-0 pa-0 pl-1 pr-1",
                          attrs: {
                            width: "auto",
                            height: "50px",
                            id: "back_clean_btn1",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              _vm.groupEditDialogVisible = true
                            },
                          },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "end" },
                            },
                            [
                              _c("v-img", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  "max-height": "2rem",
                                  "max-width": "2rem",
                                  src: require("@/assets/images/icon_store.png"),
                                },
                              }),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-1",
                                  staticStyle: { color: "#979FB1" },
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.storeCount +
                                          _vm.tsg("store") +
                                          " / " +
                                          _vm.tsg("camera") +
                                          _vm.cameraCount +
                                          _vm.t("ea")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("v-img", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  "max-height": "1rem",
                                  "max-width": "1rem",
                                  src: require("@/assets/images/corner_bottom_arrow.png"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "back_clean_btn ma-0 pa-0 pl-1 pr-1 ml-5",
                          attrs: {
                            width: "auto",
                            height: "50px",
                            id: "back_clean_btn2",
                            elevation: "0",
                          },
                          on: {
                            click: function ($event) {
                              _vm.shareUserDialogVisible = true
                            },
                          },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: { align: "end" },
                            },
                            [
                              _c("v-img", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  "max-height": "1.5rem",
                                  "max-width": "1.25rem",
                                  src: require("@/assets/images/icon_user.png"),
                                },
                              }),
                              _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-1",
                                  staticStyle: { color: "#979FB1" },
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.t("total") +
                                          _vm.shareUserCount +
                                          _vm.t("peopleInTotal")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("v-img", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  "max-height": "1rem",
                                  "max-width": "1rem",
                                  src: require("@/assets/images/corner_bottom_arrow.png"),
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "back_clean_btn ma-0 pa-0 pl-1 pr-1 ml-5",
                                            attrs: {
                                              width: "auto",
                                              height: "50px",
                                              id: "back_clean_btn3",
                                              elevation: "0",
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [
                                        _c("v-img", {
                                          staticClass: "ma-0 pa-0",
                                          attrs: {
                                            "max-height": "1.75rem",
                                            "max-width": "1.75rem",
                                            src: require("@/assets/images/cog_corner_arrow.png"),
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3381870635
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "ma-0 pa-0" },
                            [
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "ma-0 pa-2",
                                  staticStyle: {
                                    "border-bottom": "1px solid #4A4A4A",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.editGroupNameDialogVisible = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "list_font" },
                                    [_vm._v(_vm._s(_vm.tsg("renameTheGroup")))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "ma-0 pa-2",
                                  staticStyle: {
                                    "border-bottom": "1px solid #4A4A4A",
                                  },
                                  on: { click: _vm.requestDeleteStoreGroup },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "list_font" },
                                    [_vm._v(_vm._s(_vm.tsg("removeGroup")))]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                {
                                  staticClass: "ma-0 pa-2",
                                  on: { click: _vm.requestChangeLabel },
                                },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "list_font" },
                                    [_vm._v(_vm._s(_vm.tsg("changeLabel")))]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("GroupEditDialog", {
        attrs: {
          dialogVisible: _vm.groupEditDialogVisible,
          fromHeader: true,
          group: _vm.currentGroup,
        },
        on: {
          update: _vm.storesUpdate,
          visible: _vm.groupEditDialogVisibleFunc,
        },
      }),
      _c("ShareUserDialog", {
        attrs: {
          dialogVisible: _vm.shareUserDialogVisible,
          group: _vm.currentGroup,
        },
        on: {
          visible: _vm.shareUserDialogVisibleFunc,
          update: _vm.shareUserUpdate,
        },
      }),
      _c("EditGroupNameDialog", {
        attrs: { dialogVisible: _vm.editGroupNameDialogVisible },
        on: {
          visible: _vm.editGroupNameDialogVisibleFunc,
          success: _vm.groupNameChangeSuccessFunc,
        },
      }),
      _c("LabelChangeDialog", {
        attrs: { dialogVisible: _vm.labelChangeDialogVisible },
        on: {
          update: _vm.labelUpdateFunc,
          visible: _vm.labelChangeDialogVisibleFunc,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }